import React, { Component } from 'react';
import { Grid, Segment, Header, Button, Message, Image, Input } from 'semantic-ui-react';
import QueryString from 'query-string';
import { CardElement } from 'react-stripe-elements';
import { Redirect } from 'react-router-dom'
import moment from 'moment';
import StpCardVisa from './stripe/img_stp_card_visa.png';
import StpCardAmex from './stripe/img_stp_card_amex.png';
import StpCardMasterCard from './stripe/img_stp_card_mastercard.png';
import StpCardDiscover from './stripe/img_stp_card_discover.png';
import StpCardJCB from './stripe/img_stp_card_jcb.png';
import StpCardDiners from './stripe/img_stp_card_diners.png';
import StpCardUnknown from './stripe/img_stp_card_unknown.png';
import Conversation from '../../component/chat/conversation';
import {connect} from 'react-redux';

import './card.css';
import CCFieldFormatter from "../../utils/CCFieldFormatter";
import {createTokenAction, createCardAction, getEphemeralKeyAction} from '../../actions/stripeActions';
import {getAppLaunchAction} from '../../actions/index';

const ccFormatter = new CCFieldFormatter()

class AddCardPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            number: {},
            expiry: {},
            cvc: {},
            errorMessage: null
        }
    }

    componentDidMount() {
        this.props.getAppLaunchAction();
    }

    render() {
        var imageSrc;

        if (this.state.number.type === "visa") {
            imageSrc = StpCardVisa
        } else if (this.state.number.type === "american express") {
            imageSrc = StpCardAmex
        } else if (this.state.number.type === "mastercard") {
            imageSrc = StpCardMasterCard
        } else if (this.state.number.type === "discover") {
            imageSrc = StpCardDiscover
        } else if (this.state.number.type === "jcb") {
            imageSrc = StpCardJCB
        } else if (this.state.number.type === "diners club") {
            imageSrc = StpCardDiners
        } else {
            imageSrc = StpCardUnknown
        }

        return (
            <Grid columns={1}>
                <Grid.Column width={16}>
                    <Header as='h4' attached='top' block>
                        Add New Card
                    </Header>
                    <Segment attached>
                        { <div className="cell example example2" id="example-2">
                            <Grid verticalAlign='middle' columns={4}>
                                <Grid.Column width={2}>
                                    <div className="row">
                                        <div className="field">
                                            <Image src={ imageSrc } />  
                                        </div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <div className="row row2">
                                        <div className="field">
                                            <Input id="example2-card-number"
                                                ref='number'
                                                onChange={ (event) => {
                                                                var formattedNumber = ccFormatter.formatAndValidateNumber(event.target.value)
                                                                this.setState({
                                                                    number: formattedNumber,
                                                                })
                                                                if (formattedNumber.isValid) {
                                                                    this.refs.expiry.focus();
                                                                }
                                                            } }
                                                value={ this.state.number.formatted || ''}
                                                placeholder='Card Number' />
                                        </div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={3}>
                                    <div className="row row2">
                                        <div className="field">
                                            <Input id="example2-card-expiry"
                                                ref='expiry'
                                                onChange={ (event) => {
                                                                var formattedExpiry = ccFormatter.formatAndValidateExpiry(event.target.value)
                                                                this.setState({
                                                                    expiry: formattedExpiry,
                                                                })
                                                                if (formattedExpiry.isValid) {
                                                                    this.refs.cvc.focus();
                                                                }
                                                            } }
                                                value={ this.state.expiry.formatted || '' }
                                                placeholder='MM/YY' />
                                        </div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={3}>
                                    <div className="row row2">
                                        <div className="field">
                                            <Input id="example2-card-cvc"
                                                ref='cvc'
                                                onChange={ (event) => {
                                                                var formattedCVC = ccFormatter.formatAndValidateCVC(event.target.value)
                                                                this.setState({
                                                                    cvc: formattedCVC
                                                                })
                                                            } }
                                                value={ this.state.cvc.formatted || '' }
                                                placeholder='CVC' />
                                        </div>
                                    </div>
                                </Grid.Column>
                            </Grid>
                            <Button
                                loading={this.props.stripe.loading}
                                type="submit"
                                primary
                                disabled={this.props.stripe.loading}
                                fluid
                                size="medium"
                                onClick={() => this._addCard()}
                            >
                                Add Card
                            </Button>
                            { this.state.errorMessage &&
                                <Message negative>
                                    { this.state.errorMessage }
                                </Message> }
                        </div> }
                    </Segment>
                </Grid.Column>
            </Grid>
        );
    }


    _addCard() {
        // //FlurryAnalytics.logEvent(className + ' - SAVE button')
        this.setState({
            errorMessage: null
        });

        if (this.validateCard()) {
            console.log(this.state.number.nonFormatted, this.state.expiry.month, this.state.expiry.year, this.state.cvc.formatted)
            this.props.createTokenAction(this.state.number.nonFormatted, this.state.expiry.month, this.state.expiry.year, this.state.cvc.formatted).then(() => {
                const {error} = this.props.stripe;
                if (error) {
                    return
                }

                this.props.createCardAction(this.props.stripe.token.id).then(() => {        
                    const {error} = this.props.stripe;
                    if (error) {
                        return
                    }
                    
                    this.setState({
                        number: {},
                        expiry: {},
                        cvc: {},
                    });
                })

            })
        }

    }

    validateCard() {
        if (!this.state.number.isValid) {
            this.setState({
                errorMessage: "Please enter your card number. Thank you"
            });
            return false;
        }

        if (!this.state.expiry.isValid) {
            this.setState({
                errorMessage: "Please enter a valid card expiry date. Thank you"
            });
            return false;
        }

        if (!this.state.cvc.isValid) {
            this.setState({
                errorMessage: "Please enter your card CVV. Thank you"
            });
            return false;
        }

        console.log('card details');

        let myCards = this.props.stripe.customer ? this.props.stripe.customer.sources.data.filter((card) => card.object === 'card') : [];
        var checkCards = myCards.filter(card => card.last4 === this.state.number.nonFormatted.substr(12) && parseInt(card.exp_month) === parseInt(this.state.expiry.month) && parseInt(String(card.exp_year).substr(2)) === parseInt(this.state.expiry.year));

        console.log(checkCards);

        if (checkCards && checkCards.length > 0) {
            this.setState({
                errorMessage: "This card has already been added to your wallet. Thank you"
            });
            return false;
        }

        return true;
    }
}

const mapStateToProps = state => {
    console.log("PRODUCTS")
    console.log(state.products)
    return {
        stripe: state.stripe,
        // profilePhoto: state.user.profilePhoto,
        // userNotifications: state.user.notifications,
        // benefitPlans: state.user.benefitPlans,
        // benefits: state.user.benefits,
        // claimOptions: state.claimOptions,
        // countryCodeOptions: state.appConfig.countryCodes,
        // products: state.products.products,
    }
}

export default connect(mapStateToProps,{
    createTokenAction, createCardAction, getEphemeralKeyAction, getAppLaunchAction
})(AddCardPage);